import en from './en';

const th = {
  ...en,
  languageSwitcher: {
    label: 'ภาษา',
    options: {
      en: 'EN',
      ja: 'JA',
      ko: 'KO',
      ms: 'MS',
      th: 'TH',
      tr: 'TR',
    },
    names: {
      en: 'อังกฤษ',
      ja: 'ญี่ปุ่น',
      ko: 'เกาหลี',
      ms: 'มลายู',
      th: 'ไทย',
      tr: 'ตุรกี',
    },
  },
  nav: {
    home: 'หน้าแรก',
    privacy: 'ความเป็นส่วนตัว',
    terms: 'ข้อกำหนด',
    smsOptIn: 'ยืนยัน SMS',
    guidelines: 'แนวทาง',
    safety: 'ความปลอดภัย',
    deleteAccount: 'ลบบัญชี',
    support: 'ช่วยเหลือ',
    download: 'ดาวน์โหลด',
    brandAriaLabel: 'หน้าแรก 7Loves',
    menuAriaLabel: 'เปิดเมนู',
  },
  store: {
    groupAriaLabel: 'ลิงก์สโตร์',
    appStoreAriaLabel: 'ดาวน์โหลดบน App Store',
    appStoreOverline: 'ดาวน์โหลดบน',
    appStoreTitle: 'App Store',
    googlePlayAriaLabel: 'รับบน Google Play',
    googlePlayOverline: 'รับบน',
    googlePlayTitle: 'Google Play',
  },
  home: {
    metaTitle: 'หน้าแรก',
    title: 'ยินดีต้อนรับสู่ 7Loves',
    subtitle: 'Blind Date - แมตช์ก่อน แล้วค่อยเปิดเผยมากขึ้น',
    intro:
      'Seven Loves เป็นแอปหาคู่สมัยใหม่ที่เน้นความสัมพันธ์ที่มีความหมาย แตกต่างจากแอปแบบปัดทั่วไป Seven Loves มอบประสบการณ์ blind-match ที่ไม่เหมือนใคร โดยผู้ใช้จะเชื่อมต่อกันก่อนและค่อย ๆ เปิดเผยโปรไฟล์ภายหลัง',
    howItWorks: 'วิธีการทำงาน',
    details:
      'ผู้ใช้จะถูกจับคู่ตามความเข้ากันได้ เริ่มพูดคุย และปลดล็อกรายละเอียดโปรไฟล์เมื่อเวลาผ่านไป แนวทางนี้ช่วยส่งเสริมความสัมพันธ์ที่จริงใจมากกว่าการปัดแบบผิวเผิน',
    primaryCta: 'ดาวน์โหลด',
    secondaryCta: 'ติดต่อเรา',
  },
  downloadPage: {
    metaTitle: 'ดาวน์โหลด',
    title: 'รับ 7Loves',
    subtitlePrefix: 'คุณสามารถไปต่อที่',
    subtitleSuffix: 'ได้จากที่นี่',
    fallback: 'หากต้องการ คุณยังสามารถใช้ลิงก์สโตร์ด้านล่างได้',
    modalTitle: 'เปิดสโตร์ไหม?',
    modalBodyPrefix: 'เราสามารถลองเปิด',
    modalBodySuffix: 'บนอุปกรณ์นี้ได้',
    primaryCta: 'เปิดสโตร์',
    secondaryCta: 'ไว้ก่อน',
    backHome: 'กลับหน้าแรก',
    destinations: {
      ios: 'App Store',
      android: 'Google Play',
    },
  },
  smsOptIn: {
    metaTitle: 'ยินยอมการยืนยันผ่าน SMS',
    title: 'ยินยอมการยืนยันผ่าน SMS',
    subtitle:
      'หากต้องการรับรหัสยืนยันแบบครั้งเดียว โปรดยืนยันว่าคุณอายุ 18 ปีขึ้นไปและกรอกหมายเลขโทรศัพท์มือถือของคุณ',
    dobLabel: 'วันเดือนปีเกิด (DD/MM/YYYY)',
    dayPlaceholder: 'DD',
    monthPlaceholder: 'MM',
    yearPlaceholder: 'YYYY',
    phoneLabel: 'หมายเลขโทรศัพท์มือถือ',
    phonePlaceholder: '+66 8 0000 0000',
    sendCode: 'ส่งรหัสยืนยัน',
    disclosure:
      'เมื่อแตะ “ส่งรหัสยืนยัน” คุณยืนยันว่าคุณมีอายุ 18 ปีขึ้นไป และยินยอมรับรหัสยืนยันทาง SMS แบบครั้งเดียวจาก Seven Loves เพื่อวัตถุประสงค์ในการยืนยันตัวตน อาจมีค่าบริการข้อความและดาต้า จะไม่มีการส่งข้อความทางการตลาด',
    privacyLink: 'นโยบายความเป็นส่วนตัว',
  },
  pages: en.pages,
};

export default th;
